/**
 * @generated SignedSource<<f949cea6e2784e6225169da07a49c0b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type placementsDeleteMutation$variables = {
  id: string;
};
export type placementsDeleteMutation$data = {
  readonly deletePlacementOutput: {
    readonly placementOutput: {
      readonly id: string;
    } | null;
  };
};
export type placementsDeleteMutation = {
  response: placementsDeleteMutation$data;
  variables: placementsDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "PlacementOutput_Output",
    "kind": "LinkedField",
    "name": "deletePlacementOutput",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PlacementOutput",
        "kind": "LinkedField",
        "name": "placementOutput",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "placementsDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "placementsDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "46d814b73337b802b589573cf39510f2",
    "id": null,
    "metadata": {},
    "name": "placementsDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation placementsDeleteMutation(\n  $id: ID!\n) {\n  deletePlacementOutput(id: $id) {\n    placementOutput {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "96310ef1648030b5e35bef1b58ba3dc6";

export default node;
